import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=33fc2f8d&scoped=true"
import script from "./Goal.vue?vue&type=script&lang=js"
export * from "./Goal.vue?vue&type=script&lang=js"
import style0 from "./Goal.vue?vue&type=style&index=0&id=33fc2f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc2f8d",
  null
  
)

export default component.exports